<mat-card
    appearance="outlined"
    class="hdmui job-flow-node hdmui-background-2 hdmui-m-0"
    [class.job-flow-node--selected]="selected()"
>
    <div class="hdmui-content hdmui-p-0">
        <h2 class="hdmui-font-serif job-flow-node__title hdmui-mt-2 hdmui-mb-0">{{ workStep().opName }}</h2>
        <p class="hdmui-mt-0 hdmui-font-small">{{ workStep().masterProcessType }}</p>

        <div class="job-flow-node__details">
            <hdmui-key-value-vertical
                class="hdmui-mt-0 hdmui-mb-1"
                [key]="'DC.OPERATIONS.OPERATION_DETAILS.MACHINE' | translate"
            >
                {{ machineDisplayName() }}
            </hdmui-key-value-vertical>
            <hdmui-key-value-vertical
                class="hdmui-mt-0 hdmui-mb-1"
                [key]="'TODO.WORKSTATION_SELECTION.MACHINE_CLASS' | translate"
            >
                {{ deviceClassTranslationKey() | translate }}
            </hdmui-key-value-vertical>
            <hdmui-key-value-vertical
                class="hdmui-mt-0 hdmui-mb-1"
                [key]="'DC.NEW_OPERATION_DIALOG.GOOD_AMOUNT' | translate"
            >
                {{ workStep().cumulativeQuantity }}
            </hdmui-key-value-vertical>
            <hdmui-key-value-vertical
                class="hdmui-mt-0 hdmui-mb-1"
                [key]="'DC.NEW_OPERATION_DIALOG.WASTE_AMOUNT' | translate"
            >
                {{ workStep().cumulativeWaste }}
            </hdmui-key-value-vertical>
            <hdmui-key-value-vertical class="hdmui-mt-0 hdmui-mb-1" [key]="'DC.OPERATION_CARD.PLANNEDGOOD' | translate">
                {{ workStep().targetQuantity }}
            </hdmui-key-value-vertical>
        </div>
    </div>
</mat-card>
